// extracted by mini-css-extract-plugin
module.exports =  {"visuallyHidden":"KPP526","input":"Wysuh4"};